<template>
	<div>
		<b-row ref="toprint">
			<b-col>
				<b-table-simple v-for="(day, key) in route.days" :key="key" caption-top snmall responsive bordered>
					<caption>
						{{
							day.startDate
						}}
						{{
							niceTime(day.startTime)
						}}
					</caption>
					<b-thead head-variant="dark">
						<b-tr>
							<b-th>Est. times</b-th>
							<b-th>Location</b-th>
							<b-th>Contact</b-th>
							<b-th>Notes</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<b-tr v-for="(item, index) in day.waypoints" v-bind:key="index">
							<b-td>
								
								<p>Arrival: {{ roundTime(item.start) }}</p>
								
								<p v-if="item.end != item.start">Depart: {{ roundTime(item.end) }}</p>

							</b-td>

							<b-td>
								{{ item.name }} <span v-html="item.description"></span>
								<p class="p-1">{{ item.address.Address1 }}, {{ item.address.Address2 }}, {{ item.address.Town }}, {{ item.address.County }}, <br />{{ item.address.Postcode }}</p>
							</b-td>

							<b-td>
								<ul v-if="item.contacts">
									<li v-for="(contact, index) in item.contacts" v-bind:key="index">{{ contact.Name }} - {{ contact.Telephone }}</li>
								</ul>
							</b-td>

							<b-td>
								<ul>
									<li>Time assigned: {{ item.layOver.text }}</li>
								</ul>

								<ul v-if="item.notes">
									<li v-for="(note, index) in item.notes" v-bind:key="index">{{ note.FullName }} - {{ note.Note }}</li>
								</ul>
							</b-td>
						</b-tr>
					</b-tbody>

					<b-tfoot>
						<b-tr>
							<b-td colspan="4" variant="secondary" class="text-right">
								Total distance: <b>{{ dayDistance }}</b>
							</b-td>
						</b-tr>
						<b-tr>
							<b-td colspan="4" variant="secondary" class="text-right">
								Total time: <b>{{ dayTime }}</b>
							</b-td>
						</b-tr>
					</b-tfoot>
				</b-table-simple>
			</b-col>
		</b-row>

		<b-row class="mt-3">
			<b-col>
				<b-button variant="outline-primary" @click.prevent="downloadRoute">Download Route</b-button>
			</b-col>
		</b-row>

		<confirm ref="confirm"></confirm>
	</div>
</template>

<script>
import RoutePlanService from '@/api-services/routeplan.service';
import LogService from '@/api-services/log.service';
import AssignmentService from '@/api-services/assignment.service';
import ClockService from '@/api-services/clock.service';

import PDFService from '@/api-services/pdf.service';
import Confirm from '@/components/partials/confirm';

// import shares functions
import { dateFuncs } from '@/globs.js';

function createRoute() {
	return {
		days: [
			{
				startDate: dateFuncs.today(),
				startTime: '09:00',
				waypoints: [],
				locked: false,
				recalc: false,
				totals: {
					distance: 0,
					time: 0
				}
			}
		],
		totals: {
			distance: 0,
			time: 0
		}
	};
}

export default {
	name: 'RoutePlanPrint',

	components: {
		PDFService,
		Confirm
	},

	computed: {
		dayDistance: function () {
			return this.getMiles(this.route.days[this.selectedDay].totals.distance);
		},
		dayTime: function () {
			return this.getHoursMins(this.route.days[this.selectedDay].totals.time);
		},

		totalDistance: function () {
			return this.getMiles(this.route.totals.distance);
		},
		totalTime: function () {
			return this.getHoursMins(this.route.totals.time);
		}
	},

	data() {
		return {
			route: createRoute(),
			selectedDay: 0
		};
	},

	mounted() {
		this.fetchRoute();
	},

	methods: {
		downloadRoute() {
			let rawHTML = this.$refs.toprint.innerHTML;
			let head = '<html><head><link type="text/css" rel="stylesheet" href="https://unpkg.com/bootstrap/dist/css/bootstrap.min.css"/><link type="text/css" rel="stylesheet" href="https://unpkg.com/bootstrap-vue@latest/dist/bootstrap-vue.css"/></head><body>';
			let foot = '</body</html>';

			let dto = {
				HTML: head + rawHTML + foot,
				Zoom: 0.5,
				DisableShrinking: false
			};

			PDFService.create(dto)
				.then((response) => {
					let blob = new Blob([response.data], {
							type: 'application/pdf'
						}),
						url = window.URL.createObjectURL(blob);
					let a = document.createElement('a');
					a.href = url;
					a.download = 'cumbria_clock_company_route-' + this.$router.currentRoute.params.id + '.pdf';
					a.click();
					window.URL.revokeObjectURL(url);
				})
				.catch((error) => {
					this.handleError(error);
				});
		},

		fetchRoute() {
			RoutePlanService.get(this.$router.currentRoute.params.id).then((res) => {
				let routeDTO = res.data;

				for (const day of routeDTO.Data.days) {
					day.startDate = dateFuncs.humanDateFormat(day.startDate);

					for (const waypoint of day.waypoints) {
						if (waypoint.type == 4) {
							// if it's a job then get notes

							LogService.get('Assignment', waypoint.sourceId).then((res) => {
								this.$set(waypoint, 'notes', res.data);
							});

							let assignmentId = waypoint.sourceId;

							AssignmentService.get(assignmentId).then((res) => {
								//this.$set(waypoint, 'notes', res.data);

								let clockId = res.data.ClockId;
								ClockService.get(clockId).then((res) => {
									this.$set(waypoint, 'contacts', res.data.Contacts);
								});
							});
						}
					}
				}

				this.route = routeDTO.Data;
			});
		},

		async fetchNotes(id) {
			const response = await LogService.get('Assignment', id);
			return await response;
		},



		// helper functions
		niceTime(time) {
			return dateFuncs.getTime(time);
		},
		
		roundTime(time) {
			var just_time = dateFuncs.getTime(time).split(":");
			var m = (((just_time[1] + 7.5)/15 | 0) * 15) % 60;
			var h = ((((just_time[1]/105) + .5) | 0) + just_time[0]) % 24;
			return (h + ':' + (m<10?'0':'') + m);
		},


		getMiles(i) {
			return (i * 0.000621371192).toFixed(2) + ' mi';
		},

		getHoursMins(d) {
			d = Number(d);
			var h = Math.floor(d / 3600);
			var m = Math.floor((d % 3600) / 60);
			var hDisplay = h > 0 ? h + (h == 1 ? ' hour, ' : ' hours, ') : ' 0 hours ';
			var mDisplay = m > 0 ? m + (m == 1 ? ' min' : ' mins') : ' 0 mins';
			return hDisplay + mDisplay;
		},

		withBr(str) {
			return !str || 0 === str.length ? '' : str + '</br>';
		},

		handleError(err) {
			let modal_options = {
				text: 'light',
				background: 'danger'
			};

			let message;

			if (err.response.data != '') {
				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;
			} else {
				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/routeplan/routeplan-print.vue